import fileExtension from './file-extension.js';

/**
 * The list of file types for the backpack.
 */
export const BackpackFileTypes = {
  Video: 'BackpackFileTypeVideo',
  Photo: 'BackpackFileTypePhoto',
  Generic: 'BackpackFileTypeGeneric'
};

/**
 * Take a given filename and return the BackpackFileType
 * associated with it.
 *
 * @export
 * @param {String} filename The filename of the file.
 * @returns
 */
export function fileType(filename) {
  let fileExtensionMap = {
    'mp4': BackpackFileTypes.Video,
    'mov': BackpackFileTypes.Video,
    'png': BackpackFileTypes.Photo,
    'jpeg': BackpackFileTypes.Photo,
    'jpg': BackpackFileTypes.Photo
  };

  let foundType = fileExtensionMap[fileExtension(filename)];
  return foundType || BackpackFileTypes.Generic;
}



// WEBPACK FOOTER //
// ./src/utils/file-type.js